import { useState, useCallback, useMemo } from 'react';
import { useVisiblePolling } from './useVisiblePolling';
import { api } from '../api/client';
import type { AgentLaneStatus } from '../api/types';

// Shared poll of the federation-wide lane-status (#1251). Feeds the Work-Board, the
// agent-list badges, and the blocked-toast. Silent on error (endpoint may be absent on
// a node) — keeps the last good data. Mostly the PASSIVE live_state; explicit
// declarations (done/blocked/waiting) layer on top.
export function useLaneStatus(pollMs = 5000) {
  const [agents, setAgents] = useState<AgentLaneStatus[]>([]);

  const reload = useCallback(async () => {
    try {
      const r = await api.agents.status();
      setAgents(r.agents || []);
    } catch {
      /* endpoint absent / transient — keep prior data */
    }
  }, []);

  // Sichtbarkeitsgebunden statt stur (Clouds Messung 2026-08-09: ~112
  // Peer-Anfragen pro Minute auf arkserver). Dieser Takt war der heißeste im
  // ganzen Portal — alle 5 Sekunden, aus App.tsx dauerhaft eingehängt, und als
  // einziger OHNE Sichtbarkeitsprüfung, obwohl der Helfer seit Juni existiert.
  // Ein Tab im Hintergrund hat damit rund um die Uhr zwölf föderierte Abfragen
  // pro Minute erzeugt, die niemand gelesen hat. Sichtbar bleibt es bei 5 s,
  // weil davon die Blockiert-Meldung und die Abzeichen in der Agentenliste
  // hängen; verdeckt reicht eine Minute, und beim Zurückkommen wird sofort neu
  // geladen.
  useVisiblePolling(reload, pollMs);

  const byName = useMemo(() => {
    const m = new Map<string, AgentLaneStatus>();
    for (const a of agents) m.set(a.name, a);
    return m;
  }, [agents]);

  return { agents, byName, reload };
}
